import { object, string } from 'yup';

const ScaleFormValidation = () =>
  object().shape({
    name: string().required(),
    pattern: string().required(),
  });

export default ScaleFormValidation;
